import type { Neutral } from "./types";

const neutrals: Neutral[] = [
  { id: "accelgor", image: "neutrals/accelgor.png", name: "Accelgor", dex: 617 },
  { id: "altaria", image: "neutrals/altaria.png", name: "Altaria", dex: 334 },
  { id: "baltoy", image: "neutrals/baltoy.png", name: "Baltoy", dex: 343 },
  { id: "bunnelby", image: "neutrals/bunnelby.png", name: "Bunnelby", dex: 659 },
  { id: "escavalier", image: "neutrals/escavalier.png", name: "Escavalier", dex: 589 },
  { id: "groudon", image: "neutrals/groudon.png", name: "Groudon", dex: 383 },
  { id: "indeedee", image: "neutrals/indeedee.png", name: "Indeedee", dex: 876 },
  { id: "kyogre", image: "neutrals/kyogre.png", name: "Kyogre", dex: 382 },
  { id: "natu", image: "neutrals/natu.png", name: "Natu", dex: 177 },
  { id: "rayquaza", image: "neutrals/rayquaza.png", name: "Rayquaza", dex: 384 },
  { id: "regidrago", image: "neutrals/regidrago.png", name: "Regidrago", dex: 895 },
  { id: "regice", image: "neutrals/regice.png", name: "Regice", dex: 378 },
  { id: "regieleki", image: "neutrals/regieleki.png", name: "Regieleki", dex: 894 },
  { id: "regirock", image: "neutrals/regirock.png", name: "Regirock", dex: 377 },
  { id: "registeel", image: "neutrals/registeel.png", name: "Registeel", dex: 379 },
  { id: "salac", image: "neutrals/salac.png", name: "Salac Berry" },
  { id: "sitrus", image: "neutrals/sitrus.png", name: "Sitrus Berry" },
  { id: "xatu", image: "neutrals/xatu.png", name: "Xatu", dex: 178 },
];

export default neutrals;
